import { render, staticRenderFns } from "./BookingRequestPreviewCard.vue?vue&type=template&id=01423ac6&"
import script from "./BookingRequestPreviewCard.vue?vue&type=script&lang=ts&"
export * from "./BookingRequestPreviewCard.vue?vue&type=script&lang=ts&"
import style0 from "./BookingRequestPreviewCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports